import {
  FETCH_ALL_CAMPAIGN,
  FETCH_ALL_CAMPAIGN_SUCCEED,
  FETCH_ALL_CAMPAIGN_FAILED,
  ADD_CAMPAIGN,
  ADD_CAMPAIGN_SUCCEED,
  ADD_CAMPAIGN_FAILED,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCEED,
  UPDATE_CAMPAIGN_FAILED,
  UPDATE_CAMPAIGN_CONFIG,
  UPDATE_CAMPAIGN_CONFIG_SUCCEED,
  UPDATE_CAMPAIGN_CONFIG_FAILED,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_SUCCEED,
  DELETE_CAMPAIGN_FAILED,
} from './action_types';

export default {
  // fetchAllCampaign
  onFetchAllCampaignAction: (params, callback) => ({
    type: FETCH_ALL_CAMPAIGN,
    params,
    callback,
  }),
  onFetchAllCampaignActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_ALL_CAMPAIGN_SUCCEED,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  onFetchAllCampaignActionFailed: (err) => ({
    type: FETCH_ALL_CAMPAIGN_FAILED,
    err,
  }),

  // addCampaign
  onAddCampaignAction: (params, callback1, callback2) => ({
    type: ADD_CAMPAIGN,
    params,
    callback1,
    callback2,
  }),
  onAddCampaignActionSucceed: (data, callback) => ({
    type: ADD_CAMPAIGN_SUCCEED,
    params: {
      data,
      callback,
    },
  }),
  onAddCampaignActionFailed: (err) => ({
    type: ADD_CAMPAIGN_FAILED,
    err,
  }),

  // updateCampaign
  onUpdateCampaignAction: (params, callback1, callback2) => ({
    type: UPDATE_CAMPAIGN,
    params,
    callback1,
    callback2,
  }),
  onUpdateCampaignActionSucceed: (data, callback) => ({
    type: UPDATE_CAMPAIGN_SUCCEED,
    params: {
      data,
      callback,
    },
  }),
  onUpdateCampaignActionFailed: (err) => ({
    type: UPDATE_CAMPAIGN_FAILED,
    err,
  }),

  // updateCampaignConfig
  onUpdateCampaignConfigAction: (data) => ({
    type: UPDATE_CAMPAIGN_CONFIG,
    data,
  }),
  onUpdateCampaignConfigActionSucceed: (data) => ({
    type: UPDATE_CAMPAIGN_CONFIG_SUCCEED,
    data,
  }),
  onUpdateCampaignConfigActionFailed: (err) => ({
    type: UPDATE_CAMPAIGN_CONFIG_FAILED,
    err,
  }),

  // deleteCampaign
  onDeleteCampaignAction: (params, callback1, callback2) => ({
    type: DELETE_CAMPAIGN,
    params,
    callback1,
    callback2,
  }),
  onDeleteCampaignActionSucceed: (data, callback) => ({
    type: DELETE_CAMPAIGN_SUCCEED,
    params: {
      data,
      callback,
    },
  }),
  onDeleteCampaignConfigActionFailed: (err) => ({
    type: DELETE_CAMPAIGN_FAILED,
    err,
  }),

};
